import { Severity } from '../types/severity';
import * as S from './styles';

declare type CalloutProps = {
    label?: string;
    title?: string;
    description?: string;
    type?: Severity;
}

export default function Callout({ label, title, description, type }: CalloutProps) {
    return (
        <S.Container>
            {label && <S.Label>{label}</S.Label>}
            <S.InnerBox $type={type}>
                <S.Value $type={type}>{title}</S.Value>
                {description && <S.Subtitle>{description}</S.Subtitle>}
            </S.InnerBox>
        </S.Container>
    )
}